import { Avatar, Box, Heading, ScaleFade, SimpleGrid } from '@chakra-ui/react'
import React, { useContext, useEffect, useState, useMemo } from 'react'
import { FaArrowLeft } from "react-icons/fa";
import { Link, useLocation } from 'react-router-dom'
import BackgroundImage from '../components/CardsLayout/BackgroundImage'
import Category from '../components/CardsLayout/Category'
import FooterCard from '../components/CardsLayout/Footer'
import Info from '../components/CardsLayout/Info'
import Reward from '../components/CardsLayout/Reward'
import SocialMedia from '../components/SocialMedia'
import { dictionary } from '../dictionary'
import { viewPromotionDataLayer } from '../utils/gtmDatalayer'
import { SearchBar } from '../components/SearchBar/SearchBar'
import { RiCloseFill, RiSearchLine } from 'react-icons/ri'
import { MainContext } from '../context'

// Nota: dv_name es el nombre de la oferta, name es el nombre de la sucursal

export const Venues = ({ skin, fontFamily, accentColor, lang }) => {
  const { state } = useLocation()
  const { businessData } = state

  const [isOverlay, setOverlay] = useState(false)
  const [currentSocial, setCurrentSocial] = useState()
  const [currentWeb, setCurrentWeb] = useState()
  const [dataLayer, setDataLayer] = useState({ attemps: 0, data: [] })
  const contextService = useContext(MainContext)

  const [isExpanded, setExpanded] = useState(false)

  const [term, setTerm] = useState('')
  const [debouncedTerm, setDebouncedTerm] = useState('')

  const [modalType, setModalType] = useState('')
  const [currentOffer, setCurrentOffer] = useState()

  const handleNameSearch = useMemo(() => {
    if (debouncedTerm) {
      return businessData?.filter((business) => {
        return business.business.name
          .toLowerCase()
          .includes(debouncedTerm.toLowerCase())
      })
    } else {
      return businessData
    }
  }, [businessData, debouncedTerm])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    window.postMessage('rewards', '*')
  }, [])

  // Pushing dataLayer for view promotion
  useEffect(() => {
    if (dataLayer.attemps === 1) {
      viewPromotionDataLayer(dataLayer.data, dictionary[lang], skin)
    }
  }, [dataLayer])

  useEffect(() => {
    if (dataLayer.attemps === 0 && businessData.length > 0) {
      setDataLayer({ attemps: 1, data: handleNameSearch })
    }
    return () => {
      setDataLayer({ attemps: 0, data: [] })
    }
  }, [handleNameSearch])

  const handleClose = () => {
    if (term === undefined || term.length <= 2) {
      setTerm()
      setDebouncedTerm('')
      setExpanded(false)
    } else {
      setTerm()
      setDebouncedTerm('')
      setExpanded(false)
      handleNameSearch()
    }
  }

  /*const renderSearchBar = () => {
    return isExpanded === false ? null : (
      <SearchBar
        accentColor={accentColor}
        contextService={contextService}
        dictionary={dictionary[lang]}
        fontFamily={fontFamily}
        isExpanded={isExpanded}
        setDebouncedTerm={setDebouncedTerm}
      />
    )
  }*/

  const renderIcon = () => {
    return isExpanded === false ? (
      <Box id='searchName' onClick={() => setExpanded(true)}>
        <RiSearchLine
          fontSize='2rem'
          color='#001B69'
          style={{ cursor: 'pointer' }}
        />
      </Box>
    ) : (
      <Box id='closeSearch' onClick={() => handleClose()}>
        <RiCloseFill
          style={{ marginLeft: '.6rem', cursor: 'pointer' }}
          color='#001B69'
          fontSize='2.2rem'
        />
      </Box>
    )
  }

  const renderSocial = () => {
    return (
      <SocialMedia
        accentColor={accentColor}
        fontFamily={fontFamily}
        skin={skin}
        isOverlay={isOverlay}
        currentSocial={currentSocial}
        currentWeb={currentWeb}
        handleOverlay={(socialMedia) => {
          setOverlay(false)
          setCurrentSocial(socialMedia)
        }}
        modalType={modalType}
        dictionary={dictionary[lang]}
        offer={currentOffer}
      />
    )
  }

  return (
    <Box
      p={
        skin === 'CLARA'
          ? ['0rem 1rem', '0rem 2rem', '0rem 3rem', '1rem 4rem']
          : ['1rem 1rem', '1rem 2rem', '2rem 3rem', '2rem 4rem']
      }
      bg='brand.bg'
      minHeight='100vh'
    >
      <Box>
        <Link to='/'>
          <Heading
            color={skin === 'COPPEL' ? 'brand.secondaryLight' : accentColor}
            cursor='pointer'
            textDecoration={skin === 'COPPEL' ? 'none' : skin === 'ALBO' ? 'none' :'underline'}
            m='0'
            fontSize={['m', 'm', 'm', 'm']}
            mt='.2rem'
            fontFamily={fontFamily}
            fontWeight='600'
            display='flex'
            alignItems='center'
            gridColumnGap='2px'
            _hover={{
              color: skin === 'ALBO' ? '#F8644F': null
            }}
          >
            <FaArrowLeft />
            Regresar
          </Heading>
        </Link>
        <Box
          w='100%'
          display='flex'
          alignItems='center'
          justifyContent='flex-end'
          cursor='pointer'
        >
        </Box>
      </Box>
      <Box
        w='100%'
        h='auto'
        mb={['15px', '15px', '15px', '0px']}
        p={
          skin === 'CLARA'
            ? ['1rem 0rem', '1rem 0rem', '2rem 0rem', '1rem 4rem']
            : ['2rem 0rem', '2rem 0rem', '3rem 0rem', '3rem 4rem']
        }
      >
        <Box w='100%'>
          <Box
            w='100%'
            display='flex'
            flexDirection='column'
            marginBottom='2rem'
            gridRowGap='1rem'
          >
            <Avatar
              showBorder
              size='xl'
              borderColor='brand.avatarBorder'
              bg='white'
              borderWidth='4px'
              src={businessData[0].media}
              fontFamily={fontFamily}
            />
            <Box w='100%' display='flex' flexDirection='column'>
              <Heading
                color={
                  skin === 'COPPEL' ? 'brand.secondary' : 'brand.secondaryDark'
                }
                m='0'
                fontSize={['xl', '2xl', '3xl', '3xl']}
                fontFamily={fontFamily}
                fontWeight='500'
              >
                {businessData[0].business.name}
              </Heading>
              <Category
                lang={lang}
                item={businessData[0]}
                fontFamily={fontFamily}
                accentColor={accentColor}
                skin={skin}
              />
            </Box>
          </Box>

          <Box w='100%' pt={skin === 'CLARA' ? '0rem' : '1rem'}>
            <Box>
              <Box w='100%' display='flex' flexDirection='row'>
                <Box w='100%' display='flex' flexDirection='column'>
                  <SimpleGrid
                    columns={[1, 1, 2, 2, 3]}
                    spacingX='20px'
                    spacingY='20px'
                  >
                    {handleNameSearch.map((item, index) => (
                      <ScaleFade
                        key={`${item.venue._id}${index}`}
                        initialScale={0}
                        in
                      >
                        <Box
                          shadow={
                            skin === 'REWORTH' ||
                            skin === undefined ||
                            skin === ''
                              ? '2px 3px 4px #2E58FF4D'
                              : skin === 'INVEX'
                              ? '2px 3px 4px #585A5F33'
                              : skin === 'FINSUS'
                              ? '2px 3px 4px #8c8c8c33'
                              : skin === 'UNIQ'
                              ? '2px 2px 3px 0px rgba(88, 90, 95, 0.20), -1px 0px 4px 0px rgba(88, 90, 95, 0.20)'
                              : skin === 'LIVERPOOL'
                              ? '2px 2px 3px 0px rgba(88, 90, 95, 0.20), -1px 0px 4px 0px rgba(88, 90, 95, 0.20)'
                              : skin === 'SUBURBIA'
                              ? '2px 2px 3px 0px rgba(88, 90, 95, 0.20), -1px 0px 4px 0px rgba(88, 90, 95, 0.20)'
                              : skin === 'ALBO'
                              ? '0px 3px 6px 0px rgba(0, 0, 0, 0.12)'
                              : null
                          }
                          bgImage={
                            skin === 'REWORTH' ||
                            skin === undefined ||
                            skin === ''
                              ? 'linear-gradient(288deg, #FFFFFF 0%, #E8ECFB 100%)'
                              : null
                          }
                          bgColor={skin === 'REWORTH' ? null : 'brand.cardBG'}
                          borderRadius='lg'
                          display='flex'
                          alignItems='center'
                          justifyContent='center'
                          flexDirection='column'
                          h='auto'
                        >
                          <BackgroundImage
                            item={item}
                            accentColor={accentColor}
                            fontFamily={fontFamily}
                            skin={skin}
                          />
                          <Box w='100%' h='auto' p='1rem'>
                            <Box w='100%'>
                              <Info
                                item={item}
                                fontFamily={fontFamily}
                                skin={skin}
                              />
                              <Category
                                lang={lang}
                                item={item}
                                fontFamily={fontFamily}
                                accentColor={accentColor}
                                skin={skin}
                              />
                              <Reward
                                item={item}
                                fontFamily={fontFamily}
                                dictionary={dictionary[lang]}
                                skin={skin}
                              />
                              <FooterCard
                                item={item}
                                accentColor={accentColor}
                                fontFamily={fontFamily}
                                dictionary={dictionary[lang]}
                                skin={skin}
                                setOverlay={(socialMedia, webMedia, val) => {
                                  setOverlay(val)
                                  setCurrentSocial(socialMedia)
                                  setCurrentWeb(webMedia)
                                  setCurrentOffer(item)
                                }}
                                setModalType={setModalType}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </ScaleFade>
                    ))}
                  </SimpleGrid>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        {currentSocial === undefined ? null : renderSocial()}
      </Box>
    </Box>
  )
}
